/* eslint-disable import/prefer-default-export */
import _get from 'lodash/get'
import { Map, List, fromJS } from 'immutable'
import { get as apiGet, TYPE_BROOKLYN } from 'api-client'
import { getMultiplePmSections } from 'services/pm-section/actions'
import { getPmScreenProcessing } from '.'
import {
  setPmScreen as setPmScreenAction,
  setPmScreenError as setPmScreenErrorAction,
  setPmScreenProcessing as setPmScreenProcessingAction,
} from './actions'

/**
 * Get a page manager screen and dispatch actions
 * @param {Object} options The options
 * @param {import('redux').Dispatch} options.dispatch A redux dispatch function
 * @param {Map} options.auth The auth state
 * @param {Map} options.pmScreen The page manager screen state
 * @param {String} options.screenType The page manager screen type
 * @param {String} options.language The requested language
 * @param {Number} options.sectionsLimit A limit for the number of sections
 */
export async function getPmScreen (options = {}) {
  const {
    auth = Map(),
    pmScreen = Map(),
    dispatch,
    screenType,
    language,
    sectionsLimit,
  } = options
  try {
    if (getPmScreenProcessing({ pmScreen, screenType, language })) {
      return
    }
    dispatch(setPmScreenProcessingAction(screenType, language, true))
    const response = await apiGet(`page-manager/screen/${screenType}`, { language, peopleRowFeature: 'true' }, { auth }, TYPE_BROOKLYN)
    const data = fromJS(_get(response, 'body', {}))
    dispatch(setPmScreenAction(screenType, language, data))
    const sectionIds = data.get('sectionIds') || List()
    dispatch(getMultiplePmSections({ sectionIds, screenType, limit: sectionsLimit }))
  } catch (e) {
    dispatch(setPmScreenErrorAction(screenType, language, e))
  }
}
